import React, { Component } from "react";
import { Link } from "react-router";

const tabs = [
  { label: "Upcoming meetings", url: "/upcoming" },
  { label: "Current meetings", url: "/current" },
  { label: "Recorded meetings", url: "/recorded" },
  { label: "View Summary", url: "/all" },
];

class StudyGroupSuperhostWebinarsWrapper extends Component {
  render() {
    const {
      params: { id },
      location,
    } = this.props;

    return (
      <div>
        <NavigationButtons
          pathname={location.pathname}
          tabs={tabs}
          groupId={id}
        />
        {this.props.children}
      </div>
    );
  }
}

export default StudyGroupSuperhostWebinarsWrapper;

class NavigationButtons extends Component {
  render() {
    const { tabs, groupId, pathname } = this.props;

    const getUrl = (url) => `/groups/${groupId}/webinars${url}`;

    const isActive = (url) => pathname.includes(url);

    return (
      <div className="group-navigation-webinar">
        {tabs.map(({ label, url }, idx) => {
          const [first, last] = label.split(" ");

          return (
            <Link
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
              className={`group-webinar-button ${
                isActive(url) ? "active" : ""
              }`}
              to={getUrl(url)}
              key={idx}
            >
              <div>{first}</div>
              <div>{last}</div>
            </Link>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostWebinarsWrapper.jsx